import { render, staticRenderFns } from "./table.vue?vue&type=template&id=3b345547&scoped=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"
import style0 from "./table.vue?vue&type=style&index=0&id=3b345547&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b345547",
  null
  
)

export default component.exports